import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PlaidAccount from "../../models/PlaidAccount.js";

export default function usePlaidAccounts() {
	const plaidAccountsRaw = useSelector((state) => state.plaid.plaidAccountsRaw);
	const plaidAccounts = useMemo(() => {
		if(!plaidAccountsRaw) {
			return null;
		}
		return plaidAccountsRaw.map((plaidAccount) => {
			return PlaidAccount.retrieve(plaidAccount);
		});
	}, [plaidAccountsRaw]);
	return plaidAccounts;
}